import { LegalEntityContactViewModel } from "./legalEntityContactTab/LegalEntityContactTab.types";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalEntityContactsQuery(legalEntityId: string | undefined) {
    const url = `/LegalEntityContacts/${legalEntityId}`;
    return useDotLegalQuery<LegalEntityContactViewModel>(url);
}
